module.exports = __webpack_public_path__ + "images/_/programs/epsHybridPrimaries/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/images/characters/sara_giggle.png
// module id = 866
// module chunks = 2